import React from "react";
import {
  Link as LinkIcon,
  HardDrive,
  FileType,
  AlertCircle,
  X,
} from "lucide-react";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const LinkTab: React.FC<Props> = ({ value, onChange }) => {
  const handleClear = () => onChange("");

  return (
    <div className="animate-in fade-in slide-in-from-bottom-2 duration-300 py-6">
      <div className="flex items-center justify-between mb-3">
        <label className="text-sm font-semibold text-slate-700">
          Paste URL
        </label>
        {value && (
          <button
            onClick={handleClear}
            className="flex items-center gap-1.5 text-xs text-slate-500 hover:text-slate-700 transition-colors"
          >
            <X size={14} />
            Clear
          </button>
        )}
      </div>

      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
          <LinkIcon size={20} />
        </div>
        <input
          type="url"
          className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all text-slate-700 placeholder:text-slate-400"
          placeholder="https://docs.google.com/document/d/..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>

      {/* Rest of your supported sources & warnings unchanged */}
      <div className="mt-6">
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3">
          Supported Sources
        </p>
        <div className="flex flex-wrap gap-4 mb-4">
          <div className="flex items-center gap-2 px-3 py-2 bg-blue-50 text-blue-700 rounded-lg text-sm font-medium border border-blue-100">
            <HardDrive size={16} /> Google Drive
          </div>
          <div className="flex items-center gap-2 px-3 py-2 bg-orange-50 text-orange-700 rounded-lg text-sm font-medium border border-orange-100">
            <FileType size={16} /> Substack / Medium
          </div>
          <div className="flex items-center gap-2 px-3 py-2 bg-green-50 text-green-700 rounded-lg text-sm font-medium border border-green-100">
            <FileType size={16} /> freeCodeCamp
          </div>
          <div className="flex items-center gap-2 px-3 py-2 bg-purple-50 text-purple-700 rounded-lg text-sm font-medium border border-purple-100">
            <FileType size={16} /> Public Articles
          </div>
        </div>

        <div className="space-y-3">
          <div className="flex items-start gap-2 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
            <AlertCircle
              size={16}
              className="mt-0.5 flex-shrink-0 text-yellow-600"
            />
            <p className="text-xs text-yellow-800 leading-relaxed">
              <strong>Google Drive:</strong> Ensure sharing is enabled to
              "Anyone with the link"
            </p>
          </div>
          <div className="flex items-start gap-2 p-3 bg-gray-50 border border-gray-200 rounded-lg">
            <AlertCircle
              size={16}
              className="mt-0.5 flex-shrink-0 text-gray-600"
            />
            <p className="text-xs text-gray-700 leading-relaxed">
              <strong>Public Articles & Sites:</strong> Scraping works for
              public pages, but some sites block bots.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkTab;
